import { definedMap } from "@glideapps/ts-necessities";

import { LOADING } from "common/components/types";
import type { GlideFunctionalRenderer } from "common/components/uis";
import { asEnum, asString, asBoolean, loadedDefinedMap } from "common/components/component-helpers";
import { TextBoxStyle, TextBoxJustify, TextBoxLineLimit } from "common/generator/components/text-box-types";
import TextBoxView from "../ui/views/text-box/text-box";
import { useForce } from "hooks/use-force";
import { useValueProducers } from "hooks/use-value-producers";

export const TextBoxFunctionalRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [textVP, styleVP, justifyVP, allCapsVP, allowWrappingVP, lineLimitVP] = useValueProducers(
        getValueProducers,
        ctx
    );

    const [force] = useForce();

    const textPV = definedMap(textVP, force);
    if (textPV === LOADING) return env.renderProgress();

    const text = loadedDefinedMap(textPV, asString);
    if (text === undefined || text === "") return null;

    const style = loadedDefinedMap(definedMap(styleVP, force), x => asEnum<TextBoxStyle>(x)) ?? TextBoxStyle.Body;
    const justify =
        loadedDefinedMap(definedMap(justifyVP, force), x => asEnum<TextBoxJustify>(x)) ?? TextBoxJustify.Left;
    const allCaps = loadedDefinedMap(definedMap(allCapsVP, force), asBoolean) ?? false;
    const allowWrapping = loadedDefinedMap(definedMap(allowWrappingVP, force), asBoolean) ?? true;
    const lineLimitVal =
        loadedDefinedMap(definedMap(lineLimitVP, force), x => asEnum<TextBoxLineLimit>(x)) ?? TextBoxLineLimit.None;

    let lineLimit = 0;
    switch (lineLimitVal) {
        case TextBoxLineLimit.One:
            lineLimit = 1;
            break;
        case TextBoxLineLimit.Two:
            lineLimit = 2;
            break;
        case TextBoxLineLimit.Three:
            lineLimit = 3;
            break;
        case TextBoxLineLimit.Four:
            lineLimit = 4;
            break;
        case TextBoxLineLimit.Five:
            lineLimit = 5;
            break;
        case TextBoxLineLimit.Six:
            lineLimit = 6;
            break;
    }

    return (
        <TextBoxView
            text={text}
            style={style}
            justify={justify}
            allCaps={allCaps}
            allowWrapping={allowWrapping}
            lineLimit={lineLimit}
            appKind={env.appEnvironment.appKind}
        />
    );
};
